import { useApi } from '@/api';
import { KpiCard, Page, PageSkeleton, WalletCard } from '@/components';
import { tokensMapping } from '@/utils/tokens';
import { Flex, Heading } from '@blockanalitica/ui';
import { useParams } from 'react-router-dom';
import WalletEventsTable from './WalletEventTable';

export default function UpgradeWalletPage() {
  const { walletAddress } = useParams();
  const [data, error] = useApi({
    url: `/upgrade/usds/wallets/${walletAddress}/`
  });

  if (error) {
    throw error;
  }
  if (data) {
    return (
      <Page title={<Heading size="1">Wallet</Heading>}>
        <Flex gap={['m', 's']} flexDirection={['column', 'row']}>
          <WalletCard address={data.wallet_address} />
          <KpiCard
            title="Upgraded"
            variant="usds"
            data={data}
            field="balance"
            options={{
              valueOptions: {
                currencyValueOptions: {
                  currency: tokensMapping('USDS')
                }
              }
            }}
          />
        </Flex>

        <WalletEventsTable walletAddress={walletAddress} />
      </Page>
    );
  }
  return <PageSkeleton />;
}
